import Footer from '../Components/Footer';
import Header from '../Components/Header';
import MainHome from '../Components/MainHome';
import './Home.css';

function Home() {

    return (
        <div>
            <Header/>
            <MainHome/>
            <Footer/>
        </div>
    );
}

export default Home;